import type ShouldSetSelectionRange from './types';

const shouldSetSelectionRange: ShouldSetSelectionRange = () => true;

export default shouldSetSelectionRange;
